import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=570c4bcc&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('570c4bcc')) {
      api.createRecord('570c4bcc', component.options)
    } else {
      api.reload('570c4bcc', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=570c4bcc&", function () {
      api.rerender('570c4bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25NPdww4xu75f/JS/comp/IncreaseNumber.vue"
export default component.exports